export const BRAND_NAME = 'ROYSİS Etiket Sistemleri';

export const KVKK_AYDINLATMA = {
  id: 'kvkk',
  title: '6698 Sayılı KVKK Uyarınca Veri Sorumlusu Aydınlatma Metni',
  subtitle: `${BRAND_NAME} — Kişisel Verilerin Korunması`,
  sections: [
    {
      heading: 'Genel Bilgi',
      paragraphs: [
        `İşbu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, ${BRAND_NAME} ("Platform") web uygulaması ve dijital altyapısı üzerinden yürütülen faaliyetlerde kullanıcılar, demo giriş gerçekleştiren ziyaretçiler ve müşterilere ait kişisel verilerin işlenmesine ilişkin usul ve esasları belirlemek amacıyla veri sorumlusu sıfatıyla Ömer Polat tarafından hazırlanmıştır.`,
      ],
    },
    {
      heading: '1.1. İşlenen Kişisel Verileriniz ve Toplama Yöntemleri',
      paragraphs: [
        "Platform'a kayıt olmanız, demo giriş özelliğini kullanmanız veya sistem içerisindeki panelleri yönetmeniz esnasında aşağıdaki verileriniz otomatik veya kısmen otomatik yöntemlerle dijital ortamda toplanmaktadır:",
      ],
      list: [
        'Kimlik ve İletişim Bilgileri: Kullanıcı kaydı veya demo girişi esnasında beyan edilen ad, soyad, e-posta adresi, telefon numarası.',
        'İşlem Güvenliği Bilgileri: Sisteme giriş-çıkış logları, IP adresi, kullanıcı tarayıcı (user-agent) bilgileri, oturum çerezleri (cookies) ve şifrelenmiş (hashed) erişim parolaları.',
        'Uygulama Kullanım Bilgileri: Altyapı üzerinde çalıştırılan modüller, yönetim paneli hareketleri, oluşturulan etiket, sipariş, stok, üretim veya entegrasyon kayıtları ile sistem içi yardım araçlarıyla yapılan etkileşim verileri.',
      ],
    },
    {
      heading: '1.2. Kişisel Verilerin İşlenme Amaçları',
      paragraphs: [
        "Toplanan kişisel verileriniz, KVKK'nın 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları dahilinde aşağıdaki amaçlarla işlenmektedir:",
      ],
      list: [
        'Platform üyelik süreçlerinin yürütülmesi ve demo erişim yetkilendirmelerinin yapılması,',
        'Yönetilen web sunucu altyapısı, veritabanı yönetimi ve React/Node.js/PostgreSQL tabanlı sistem mimarisinin işlem güvenliğinin sağlanması,',
        'Sistem performansının takibi, teknik hataların (bug) tespiti ve iş akışlarının geliştirilmesi,',
        'Mevzuattan kaynaklanan hukuki yükümlülüklerin yerine getirilmesi ve yetkili kamu kurum ve kuruluşlarına bilgi verilmesi (5651 sayılı Kanun kapsamındaki log tutma yükümlülükleri dahil).',
      ],
    },
    {
      heading: '1.3. İşlenen Kişisel Verilerin Aktarılması',
      paragraphs: [
        'Kişisel verileriniz; yürürlükteki mevzuata uygun olarak, yalnızca yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda ve gerekli teknik/idari tedbirler alınarak; yasal yükümlülüklerin yerine getirilmesi amacıyla adli makamlar veya yetkili kamu kurum ve kuruluşları ile paylaşılabilecektir. Verileriniz ticari amaçlarla üçüncü taraflara satılmamakta veya kiralanmamaktadır.',
      ],
    },
    {
      heading: '1.4. Kişisel Veri Sahibinin KVKK Kapsamındaki Hakları',
      paragraphs: [
        "KVKK'nın 11. maddesi uyarınca veri sahibi olarak; kişisel verilerinizin işlenip işlenmediğini öğrenme, işlenmişse buna ilişkin bilgi talep etme, işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme, yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme, eksik veya yanlış işlenmişse düzeltilmesini isteme ve verilerin silinmesini talep etme haklarına sahipsiniz. Haklarınıza ilişkin taleplerinizi sistem üzerinde kayıtlı e-posta adresiniz üzerinden tarafımıza iletebilirsiniz.",
      ],
    },
  ],
};

export const KULLANICI_SOZLESMESI = {
  id: 'terms',
  title: `${BRAND_NAME} Kullanıcı ve Hizmet Sözleşmesi`,
  subtitle: 'Platform Kullanım Şartları',
  sections: [
    {
      heading: '2.1. Sözleşmenin Tarafları ve Konusu',
      paragraphs: [
        `İşbu Kullanıcı Sözleşmesi ("Sözleşme"), ${BRAND_NAME} internet sitesine üye olan, demo hesap ile giriş yapan veya platform tarafından sunulan yazılım, API ve altyapı hizmetlerinden faydalanan kullanıcılar ile veri/sistem yöneticisi Ömer Polat arasında akdedilmiştir. Sözleşme, kullanıcının platformda yer alan dijital araçları, modülleri ve altyapıyı kullanım şartlarını ve tarafların hak/yükümlülüklerini belirler.`,
      ],
    },
    {
      heading: '2.2. Hizmetin Kapsamı ve Kullanım Koşulları',
      paragraphs: [
        `${BRAND_NAME}, etiket üretimi ve işletme yönetimi süreçlerini dijitalleştiren; muhasebe, satış, sipariş, stok, üretim, nakliye, insan kaynakları ve ilgili modülleri içeren bir ERP ekosistemidir. Demo girişi, sistemin yeteneklerinin test edilmesi amacıyla açık tutulmakta olup, bu alanda üretilen veya girilen verilerin kalıcılığı taahhüt edilmemektedir.`,
        'Önemli Güvenlik Uyarısı: Demo girişi veya kullanıcı hesapları üzerinden sisteme erişim sağlayan kullanıcılar, altyapının kararlılığını bozacak, tersine mühendislik (reverse engineering) teşkil edecek veya sunucu kaynaklarını kötüye kullanacak faaliyetlerde bulunamazlar. Tespit edilen kötü niyetli girişimlerde erişim engellenir ve yasal süreç başlatılır.',
        'Demo hesaptaki veriler herkese açıktır; kişisel veya hassas veri girişi yapılmamalıdır.',
      ],
    },
    {
      heading: '2.3. Sorumluluk Sınırları ve Mücbir Sebepler',
      paragraphs: [
        'Platform üzerinde sunulan hizmetlerin kesintisizliği, hatasızlığı veya sistem çıktılarının mutlak doğruluğu garanti edilmemektedir. Yazılımsal güncellemeler, sunucu göçleri (migration), altyapı konfigürasyonları veya telekomünikasyon altyapısından kaynaklı kesintilerden doğabilecek dolaylı zararlardan platform yönetimi sorumlu tutulamaz.',
      ],
    },
    {
      heading: '2.4. Fikrî Mülkiyet Hakları',
      paragraphs: [
        `Platformun tasarımı, kaynak kodları, geliştirilen özel modüller, veritabanı şemaları ve "ROYSİS" markasına ait tüm fikri mülkiyet hakları münhasıran platform sahibine aittir. Yazılı izin olmaksızın kısmen veya tamamen kopyalanamaz, kopyalanarak başka sunucularda türetilmiş (derived) proje olarak yürütülemez.`,
      ],
    },
    {
      heading: '2.5. Yürürlük ve Fesih',
      paragraphs: [
        'Kullanıcı, platforma kayıt olduğu veya "Demo Giriş" butonuna tıklayarak içeriğe eriştiği andan itibaren işbu sözleşmenin tüm şartlarını kabul etmiş sayılır. Platform yönetimi, sözleşme şartlarını tek taraflı olarak güncelleme hakkını saklı tutar.',
      ],
    },
  ],
};

export const LEGAL_DOCUMENTS = {
  kvkk: KVKK_AYDINLATMA,
  terms: KULLANICI_SOZLESMESI,
};
